/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";

import { Text } from "UpduoLibrary";
import { skaleTextGray } from "config/UpduoColors";

export default function DataEntry({
  heading,
  value,
}: {
  heading: string;
  value: string;
}) {
  return (
    <View style={{ flexDirection: "row" }}>
      <Text
        isHeading={true}
        style={{ color: skaleTextGray, fontSize: 16, width: 60 }}
      >
        {`${heading}:`}
      </Text>
      <Text style={{ color: skaleTextGray, fontSize: 16 }}>{value}</Text>
    </View>
  );
}
